import { TriviaList } from '@repo/types'

import { apiClient } from '@/api/api-client'
import StoreService from '@/store/StoreService'

import { useCreateTriviaList } from './useCreateTriviaList'

export function useCreateSystemTriviaList() {
  const { triviaListService } = StoreService.getStore()

  const { queryFn, queryKey } = triviaListService.queries.systemTriviaLists

  const mutationFn = (triviaList: TriviaList) => apiClient.adminCreateTriviaList(triviaList)

  return useCreateTriviaList(queryKey, mutationFn, queryFn)
}
